import React, { Component } from 'react';
import { isEmpty } from 'lodash';
import { gsap } from 'gsap';

import './style.css';

const TIMER_INTERVAL = 30;

export default class NgGameRPGEThinkTime extends Component {

    state = {
        progress: 100
    }

    timer;
    timePass; // мс
    timeToThink; // мс

    initTimeThinkFromAllEngine = ({ onThinkTimeMessage }) => {
        this.sendThinkTimePercent = (percent) => onThinkTimeMessage(percent);
    }

    clearTimer = () => {
        this.timer && clearInterval(this.timer);
        this.timer = null;
    }

    resetAll = () => {
        this.clearTimer();
        this.timeToThink = 100000;
        this.timePass = 0;

        this.setState({
            progress: 100
        })
    }

    setNewTimer = (timeToThink) => {

        if (timeToThink === 0) {
            return this.resetAll();
        }

        this.clearTimer();
        this.timeToThink = timeToThink * 1000;
        this.timePass = 0;

        this.timer = setInterval(() => {
            this.timePass += TIMER_INTERVAL;
            if (this.timePass >= this.timeToThink) {
                this.sendThinkTimePercent(0);
                this.resetAll();
            }
            const progress = 100 - Number(((this.timePass / this.timeToThink) * 100).toFixed(1));
            this.setState({ progress });
        }, TIMER_INTERVAL)

        this.setState({
            progress: 100
        })
    }

    componentDidUpdate = (_, { progress }) => {
        if ((this.state.progress < 95) && (progress >= 95)) {
            this.sendThinkTimePercent(95);
        }
        if ((this.state.progress < 80) && (progress >= 80)) {
            this.sendThinkTimePercent(80);
        }
        // if ((this.state.progress < 50) && (progress >= 50)) {
        //     this.sendThinkTimePercent(50);
        // }
        // if ((this.state.progress < 25) && (progress >= 25)) {
        //     this.sendThinkTimePercent(25);
        // }
    }

    componentWillUnmount = () => {
        this.timer && clearInterval();
        this.timer = null;
    }

    render() {
        const { arena: { width: arenaWidth, height: arenaHeight }, zIndex } = this.props;
        const { progress } = this.state;
        const innerWidth = `${progress}%`;
        const height = arenaWidth * 0.015;

        return <div style={{ zIndex, left: 0, width: arenaWidth, height, top: arenaHeight - height }} className='ngg_arena_thinktime_container'>
            <div style={{ width: innerWidth }} className='ngg_arena_thinktime_inner' />
        </div>
    }
}